import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid/Grid";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles({
    grid: {
        width: 250,
        marginLeft: 20,
    },
    location: {
        width: 120
    },
    zipCode: {
        width: 120,
        paddingLeft: 30
    },
    formControl: {
        width: '100%'
    },
});

export default function LocationDesktop(props) {

    const [open, setOpen] = React.useState(true);

    const [counter, setCounter] = React.useState(0);

    const classes = useStyles();

    const params = props.filter.params;

    const filter = props.filter;

    const handleDistanceChange = (e) => {
        params.distance = +e.target.value;
        render();
        filter.dispatchFilter();
    };

    const handleZipCodeChange = (e) => {
        params.zipCode = e.target.value;
        filter.dispatchFilter();
        render();
    };

    const handleOpenClick = () => {
        setOpen(!open);
    };

    const render = () => {
        setCounter(counter + 1);
    };

    const years = [];
    for (let i=params.minYearLimit;i<=params.maxYearLimit; i++) {
        years.push(i);
    }

    const distance = params.distance;
    const zipCode = params.zipCode === null ? null : params.zipCode;

    const values = [10, 25, 50, 75, 100, 200, 300, 400, 500, params.distanceLimit];

    return (<>
        <div className={props.classes.block}>
            <div className={props.classes.opener} onClick={handleOpenClick}>
                {open ? <RemoveIcon/> : <AddIcon/>}
            </div>
            <div className={props.classes.blockHeader} onClick={handleOpenClick}><Typography><b>Location</b></Typography></div>
            {open ? <div className={props.classes.makes}><div className={props.classes.makesCont}>
                <Grid container className={classes.grid}>
                    <Grid item className={classes.location}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="distance">Search Within</InputLabel>
                            <Select
                                native
                                value={distance}
                                onChange={handleDistanceChange}
                                inputProps={{
                                    name: 'distance',
                                    id: 'distance',
                                }}
                            >
                                {values.map(value => {
                                    return <option value={value} selected={value === distance}>
                                        {value === params.distanceLimit ? "Any Distance" : (value + " Miles")}
                                    </option>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item className={classes.zipCode}>
                        <TextField
                            id="zipCode"
                            label="ZIP Code"
                            name="zipCode"
                            value={zipCode ? zipCode : ''}
                            onChange={handleZipCodeChange}
                        />
                    </Grid>
                </Grid>
            </div></div> : null}
        </div>
    </>)
}